import { tv } from "tailwind-variants";

export const inputStyle = tv({
  base: "border-2 bg-white rounded-3 border-grey-10 text-black outline-hidden flex items-center min-w-0",
  variants: {
    size: {
      l: "h-14",
      sm: "h-8",
    },
    hasLeftIcon: {
      true: "pl-12 pr-4",
      false: "px-4",
    },
    isFocused: {
      true: "border-black",
    },
    isInvalid: {
      true: "border-red",
    },
    isDisabled: {
      true: "border-grey-4",
    },
  },
  defaultVariants: {
    size: "l",
  },
});

export const fieldGroupStyles = tv({
  base: "group flex items-center h-9 bg-white border-2 overflow-hidden",
  variants: inputStyle.variants,
});
